import { StatusText, type StatusTone } from '../../../../components/table/StatusText';
import { MAINTENANCE_AGING, type MaintenanceAging } from '../buildingManagementTypes';

/**
 * The tone each aging band renders in.
 *
 * **No amber, because this pill sits on an index page** — the amber `pending` tone is the brand
 * colour there and reads as chrome. Near Expiration is ORANGE (`warning`, product call 12 Oct
 * 2026), both expired bands take `blocked`, and the WORD carries the difference.
 */
const TONE: Record<MaintenanceAging, StatusTone> = {
  [MAINTENANCE_AGING.onSchedule]: 'active',
  [MAINTENANCE_AGING.nearExpiration]: 'warning',
  [MAINTENANCE_AGING.expired]: 'blocked',
  [MAINTENANCE_AGING.expiredBeyondThreshold]: 'blocked',
};

/**
 * An item's state as one pill — its aging band, or `Deleted`.
 *
 * **One pill, not two.** A deleted item is outside the monitoring question, so it shows the
 * deleted word rather than a band it is no longer aged in; the label comes from the server so
 * the escalated band reads "30 Days Expired" at whatever the setting is.
 */
export function AgingStatus({
  aging,
  label,
  isActive,
}: {
  aging: MaintenanceAging;
  label: string;
  isActive: boolean;
}) {
  if (!isActive) return <StatusText tone="inactive">Deleted</StatusText>;

  return <StatusText tone={TONE[aging]}>{label}</StatusText>;
}
